import { graphql } from 'react-relay';

export const ServiceAvailabilityStatusQuery = graphql`
    query serviceAvailabilityStatusQuery($serviceWithoutCredits: ServicesWithoutCredits!) {
        serviceAvailabilityStatus(serviceWithoutCredits: $serviceWithoutCredits)
    }
`;
